<template>
  <div id="default-header">
    <nav
      :class="['navbar is-fixed-top hp-container hp-container--wide']"
      role="navigation"
      aria-label="main navigation"
    >
      <template v-if="!isSearchMode">
        <div class="navbar-brand">
          <router-link class="navbar-item hellopeter-logo" to="/">
            <router-link
              tag="img"
              to="/"
              src="/static/img/logo/logo.svg"
              alt="HP Logo"
            />
          </router-link>
        </div>
        <div :class="['navbar-menu navbar-menu--left', {'is-active': !isDesktop}]">
          <div class="navbar-end jcontent-center">
            <template v-if="isDesktop">
              <router-link :to="{ name: 'WriteReview' }" class="hp-btn-link" v-if="isHomePage">
                WRITE A REVIEW
              </router-link>
              <template v-else>
                <div id="shieldLayer" v-if="orgsFound"></div>
                <business-search ref="bizSearch"/>

                <router-link :to="{ name: 'WriteReview' }" class="hp-btn-link hp-btn-link--small">
                  WRITE A REVIEW
                </router-link>
              </template>
            </template>
            <template v-else>
              <router-link to="write-a-review" class="link--v2 is-uppercase has-text-weight-semibold" :class="{'font-size-14': isTablet, 'font-size-11':isMobile}">Write a review</router-link>
            </template>
          </div>
        </div>
        <div :class="['navbar-menu navbar-menu--right', {'is-active': !isDesktop}]">
          <div class="navbar-end" :class="{'position-relative':isDesktop}">
            <template v-if="isDesktop">
              <router-link class="navbar-item padding-left-45" to="/industries">Industries</router-link>
              <a class="navbar-item padding-left-18" :href="portal_url" rel="nofollow">I’m a Business</a>
            </template>
            <template v-else>
              <a @click.prevent="turnOnSearchMode" :class="['button search-button']">
              <span class="icon">
                <i class="fas fa-search"></i>
              </span>
              </a>
            </template>
            <button
              @click.prevent="showMenu = !showMenu"
              :class="['navbar-burger']"
            >
              <span></span>
              <span></span>
              <span></span>
            </button>
            <v-popover
              v-if="showMenu"
              :open="showMenu"
              offset="37"
              popoverClass="headerMenuPopup"
              trigger="manual"
              :container="false"
            >
              <template slot="popover">
                <div>
                  <template v-if="isLoggedIn">
                    <a href="javascript:void(0);" class="navbar-item" @click="myProfilePath">My Profile & Reviews</a>
                    <hr/>
                    <router-link :to="{ name: 'WriteReview' }" class="navbar-item">
                      Write a review
                    </router-link>
                  </template>
                  <template v-else>
                    <router-link v-if="!isLoggedIn" class="navbar-item" to="/register">Create a Profile &nbsp;<span class="font-size-12 has-text-weight-normal">(Write Reviews)</span></router-link>
                    <hr/>
                    <router-link v-if="!isLoggedIn" class="navbar-item" to="/login">Sign In</router-link>
                  </template>
                  <hr/>
                  <hr/>
                  <template v-if="!isDesktop">
                    <router-link class="navbar-item padding-left-45" to="/industries">Industries</router-link>
                    <hr/>
                    <hr/>
                    <a class="navbar-item padding-left-18" :href="portal_url" rel="nofollow">I’m a Business</a>
                    <hr/>
                    <hr/>
                  </template>
                  <a class="navbar-item" :href="blog_url" rel="nofollow">Blog & Resources</a>
                  <template v-if="isLoggedIn">
                    <hr/>
                    <hr/>
                    <a class="navbar-item" @click.prevent="logout" href="#">Sign Out</a>
                  </template>
                </div>
              </template>
            </v-popover>
          </div>
        </div>
      </template>
      <template v-else>
        <div id="shieldLayer"></div>
        <business-search ref="bizSearch">
          <img src="/static/img/others/error_blue_dark.svg" @click="handleSearchClose"/>
        </business-search>
      </template>
    </nav>
  </div>
</template>
<script>
import {misc, auth} from '@/mixins'
import {BusinessSearch} from '@/components'
import {BulmaAccordion, BulmaAccordionItem} from "vue-bulma-accordion";
import {mapActions, mapWritableState} from 'pinia'
import {useHeaderBizSearchStore} from '@/stores'

export default {
  name: "DefaultHeader",
  components: {
    BusinessSearch,
    BulmaAccordion,
    BulmaAccordionItem
  },
  mixins: [misc, auth],

  data () {
    return {
      showMenu: false,
      dropdownIsActive: false,
      blog_url: process.env.BLOG_URL,
      portal_url: process.env.PORTAL_URL,
      isMounted: false
    };
  },
  created () {
    window.events.$on("mobileNavMenuSelected", () => {
      this.showMenu = false;
    });
  },
  mounted () {
    this.isMounted = true
  },
  computed: {
    ...mapWritableState(useHeaderBizSearchStore, ['isSearchMode']),

    orgsFound () {
      if (this.isMounted && this.$refs.bizSearch) {
        return this.$refs.bizSearch.orgsFound
      }
      return false
    },
    isHomePage () {
      return this.$route.name === 'Home'
    },
    getFullName () {
      const hasDisplayName = !!localStorage.getItem("displayName");
      if (hasDisplayName) {
        return localStorage.getItem("displayName");
      }
      return "";
    },
  },
  methods: {
    ...mapActions(useHeaderBizSearchStore, ['turnOnSearchMode']),

    focusSearchField () {
      this.$refs.bizSearch.$refs.searchField.focus()
    },
    handleSearchClose () {
      if (this.$refs.bizSearch.searchString) {
        this.$refs.bizSearch.searchString = ''
        this.$refs.bizSearch.orgLookup()
        this.focusSearchField()
      } else {
        this.isSearchMode = false
      }
    },
    myProfilePath () {
      this.dropdownIsActive = true;
      const hasProfileId = !!localStorage.getItem("profile_id");
      if (hasProfileId) {
        const profileId = localStorage.getItem("profile_id");
        this.$router.push(`/profile/${profileId}`);
      } else {
        this.$router.push("/");
      }
    }
  },
  watch: {
    isSearchMode () {
      if (this.isSearchMode) {
        this.$nextTick(() => {
          this.focusSearchField()
          this.$refs.bizSearch.orgLookup()
        })
      }
    }
  }
};
</script>
<style scoped lang="scss">
@import "@/assets/scss/_variables.scss";
@import "@/assets/scss/vendor/_breakpoints.scss";

#default-header {
  width: 100%;
  height: 104px;
  background-color: #ffffff;
  position: fixed;
  top: 0;
  z-index: 30;
  box-shadow: 0 1px 10px 0 rgba(0, 0, 0, 0.3);

  @include tablet {
    height: 80px;
  }

  @include mobile {
    height: 56px;
  }

  .navbar {
    height: 104px;

    @include not-desktop {
      display: flex;
      justify-content: space-between;
    }

    @include tablet {
      height: 80px;
      padding: 0 16px 0 25px;
    }

    @include mobile {
      height: 56px;
      padding: 0 10px 0 13px;
    }

    .navbar-menu--right {
      flex-grow: 0;

      @include not-desktop {
        display: flex;
        box-shadow: none;
      }
    }

    .navbar-end {
      align-items: center;
      padding-top: 7px;
      margin-left: 0;
    }

    .navbar-menu--left {
      @include not-desktop {
        box-shadow: none;
      }

      @include mobile {
        padding: 5px 0 0;
      }

      .navbar-end {
        flex-basis: 100%;

        @include not-desktop {
          height: 100%;
        }
      }
    }

    .navbar-menu.is-active .navbar-end {
      display: flex;
      padding-top: 0;
    }
  }
}


.hellopeter-logo {
  padding: 7px 45px 0 0;

  img {
    max-height: 100%;
    width: 172px;
  }

  @include tablet {
    padding-top: 1px;

    img {
      width: 121px;
    }
  }

  @include mobile {
    padding-top: 4px;
    padding-right: 5px;

    img {
      width: 90px;
    }
  }
}

@include not-desktop {
  > > > div.search-block {
    margin: 0 -16px 0 -25px;
    flex-grow: 1;

    .search-block-field {
      background: url("/static/img/magnifier/magnifier2_blue_dark.png") no-repeat left 26px center/20px;
      padding-left: 61px;
      padding-right: 65px;
      height: 100%;
      border: none;
      font-size: 16px;

      @include mobile {
        background-size: 14px;
        background-position: 26px center;
        font-size: 14px;
        padding-left: 51px;
      }
    }

    .search-block-dd {
      left: 0;
      right: 0;

      .dropdown-menu {
        width: 100%;
        padding-top: 0;

        .dropdown-content {
          padding-top: 17px !important;
          padding-bottom: 20px !important;
          border-radius: 0;

          @include mobile {
            padding-top: 0 !important;
          }

          .dropdown-item {
            color: map-get($colors, 'blue-dark');
            font-weight: 600;
            height: 40px;
            padding: 10px 25px 0;
            margin-bottom: 11px;

            &:hover {
              background-color: #d4dff6;
            }

            @include mobile {
              padding: 10px 26px 0;
              margin-bottom: 0;
            }

            .hp-btn-primary {
              font-size: 14px;
              font-weight: bold;
              text-transform: uppercase;
              height: 35px;

              img {
                width: 14px;
              }
            }
          }
        }
      }
    }

    & > img {
      position: absolute;
      right: 30px;
      top: 32px;

      @include mobile {
        width: 12px;
        top: 21px;
      }
    }
  }
}

#shieldLayer {
  position: fixed;
  top: 103px;
  bottom: 0;
  background-color: map-get($colors, 'gray');
  opacity: 0.50;
  z-index: 9;
  left: 0;
  right: 0;

  @include tablet {
    top: 80px;
  }

  @include mobile {
    top: 55px;
  }
}


.hp-btn-link {
  width: 200px;
  color: map-get($colors, 'yellow');

  &--small {
    width: 130px;
    font-size: 12px;
    min-width: 130px;
  }
}


a.navbar-item {
  &, &:focus, &:focus-within, &:hover, &.is-active {
    background-color: #fff;
    color: map-get($colors, 'blue-dark');
    font-weight: 600;
  }
}

.navbar-burger {
  display: block;
  border: 0;
  margin-top: -11px;
  margin-left: 9px;

  @include not-desktop {
    margin-left: 0;
    margin-top: -7px;
  }

  &, &:hover {
    background-color: #fff;
  }

  span {
    width: 30px;
    height: 3px;
    color: map-get($colors, 'blue-dark');

    &:nth-child(2) {
      top: calc(50% - -3px);
    }

    &:nth-child(3) {
      top: calc(50% + 12px);
    }

    @include not-desktop {
      height: 2px;
      width: 23px;

      &:nth-child(2) {
        top: calc(50% - -2px);
      }

      &:nth-child(3) {
        top: calc(50% + 10px);
      }
    }
  }
}

.search-button {
  &, &:hover, :visited {
    border: none;
    font-size: 1.2rem;
    color: map-get($colors, 'blue-dark');
    padding: 0 1rem;
  }

  @include tablet {
    padding-left: 44px;
  }

  @include mobile {
    font-size: 20px;
    padding-left: 5px;
    padding-right: 5px;
  }
}
</style>
<style lang="scss">
.headerMenuPopup.tooltip.popover {
  width: 288px;
  padding: 0;
  box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.16);
  background-color: #fff;
  font-size: 14px;

  @media screen and (max-width: 1023px) {
    & {
      top: 75px !important;
      left: 6px !important;
      width: 267px;
    }
  }

  @media screen and (max-width: 767px) {
    & {
      top: 51px !important;
      left: 5px !important;
      width: 100%;
    }
  }

  .popover-inner {
    box-shadow: none;
    background-color: #fff;
    padding: 0;

    .navbar-item {
      padding: 9px 0 8px 15px;
    }

    hr {
      height: 0.5px;
      margin: 0;
      background-color: #f0f1f2;
    }
  }

  .popover-arrow {
    display: none;
  }
}
</style>




// WEBPACK FOOTER //
// src/layouts/DefaultHeader.vue